<template>
    <div class="users-table">
        <div class="users-table__buttons">
            <TotemButton color="primary" :label="$t('UsersTable.remove_from')" />
            <TotemButton color="secondary" class="-margin-left" :label="$t('UsersTable.save')" />
        </div>
        <div class="users-table__table">
            <div class="header">
                <div class="header-cell" v-html="$t('UsersTable.user')"></div>
                <div class="header-cell" v-html="$t('UsersTable.remove')"></div>
            </div>
            <div class="row" v-for="(user, index) in users" :key="index">
                <div class="row-cell" >{{ user.name }}</div>
                <div class="row-cell" >
                    <TotemCheckbox v-model="checkData" :id="user.id" :val="user.id" :label="user.id" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data () {
            return {
                checkData: []
            }
        },
        computed: {
            ...mapGetters({
                users: 'SelfServiceForm/getUsers'
            })
        },
        created () {
            this.$store.dispatch('SelfServiceForm/loadUsers')
        }
    }
</script>

<style lang="scss" scoped>
    .users-table {
        flex-grow: 1;
        display: flex;
        flex-direction: column-reverse;

        [class*="desktop_x"] & {
            flex-direction: column;
        }

        &__table {
            margin: 20px 0;
            border: 1px solid $quill_gray;
            border-bottom: none;
            background: $white;
        }

        &__buttons {
            display: flex;
            justify-content: flex-end;
        }

        .header,
        .row {
            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            height: 40px;
            border-bottom: 1px solid $quill_gray;
            font-size: 1.8rem;
        }

        .header {
            background: $glacier;
            font-family: Nunito-Bold, sans-serif;
        }
        .row {
            display: flex;
        }

        .row-cell,
        .header-cell {
            display: flex;
            align-items: center;
        }
    }
</style>
